module.exports = __webpack_public_path__ + "static/img/guoyao_gz.6d567e80.png";